class APIMenuMapper {
  static mapCatalog(data: any[][]): CatalogItem[] {
    return data.map((item: any[]) => ({
      Id: item.data[0],
      Name: item.data[1],
      Type: item.data[2],
      Row: item.data[3]
    }));
  }

  static mapItem(data: any[][]): ItemData[] {
    return data.map((item: any[]) => ({
      Id: item.data[0],
      CatalogId: item.data[1],
      Name: item.data[2],
      BasePrice: item.data[3],
      Row: item.data[4],
      ProductCode: item.data[5],
      DiscountMode: item.data[6],
      DiscountValue: item.data[7]
    }));
  }

  static mapSubItem(data: any[][]): SubItemData[] {
    return data.map((item: any[]) => ({
      Id: item.data[0],
      ItemId: item.data[1],
      Name: item.data[2],
      Price: item.data[3],
      Row: item.data[4],
      DiscountValue: item.data[5]
    }));
  }

  // Generic mapper method that can handle all three types
  static mapData(data: any[][], type: 'catalogs' | 'items' | 'subitems'): CatalogItem[] | ItemData[] | SubItemData[] | [] {
    
    if (!data) 
      return [];
    
    switch (type) {
      case 'catalogs':
        return this.mapCatalog(data);
      case 'items':
        return this.mapItem(data);
      case 'subitems':
        return this.mapSubItem(data);
      default:
        throw new Error(`Unsupported data type: ${type}`);
    }
  }

  static catalogsJoined(catalogs: CatalogItem[], items: ItemData[], subitems: SubItemData[]): CatalogItemJoined[] {
    return catalogs.map((catalog) => {
      return {
        ...catalog,
        Items: items.filter((item) => item.CatalogId === catalog.Id).map((item) => {
          return {
            ...item,
            SubItems: subitems
              .filter((subitem) => subitem.ItemId === item.Id)
              .slice()
              .sort((a, b) => (a.Row ?? 0) - (b.Row ?? 0))
          };
        })
      }
    }) as CatalogItemJoined[];
  }
    

  
}

export default APIMenuMapper;

interface CatalogItemJoined {
  Id: number;
  Name: string;
  Type: string;
  Row: number;
  Items: {
    Id: number;
    CatalogId: number;
    Name: string;
    BasePrice: number;
    Row: number;
    ProductCode: string;
    Tags?: string[];
    DiscountMode: number;
    DiscountValue: number;
    SubItems: {
      Id: number;
      ItemId: number;
      Name: string;
      Price: number;
      Row: number;
      DiscountedPrice: number;
      Tags?: string[];
    }[]
  }[]
}

interface CatalogItem {
  Id: number;
  Name: string;
  Type: string;
  Row: number;
}

interface ItemData {
  Id: number;
  CatalogId: number;
  Name: string;
  BasePrice: number;
  Row: number;
  ProductCode: string;
  Tags?: string[];
  DiscountMode: number;
  DiscountValue: number;
}

interface SubItemData {
  Id: number;
  ItemId: number;
  Name: string;
  Price: number;
  Row: number;
  DiscountedPrice: number;
}


export { CatalogItem, ItemData, SubItemData, CatalogItemJoined }